import ReactDOM from "react-dom/client";
import { useEffect } from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "./components/NotistackPlus";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { LicenseInfo } from "@mui/x-license-pro";
import "./assets/scss/index.scss";
import { useUrfReceiveEvents } from "./hooks/urfEvents";
import { useConfigStore } from "./store/config";
import { initI18n, ensureAppLanguage } from "./locals/index";
import { stopLifecycleAsyncTaskPoll } from "./services/lifecycleAsyncTaskPoll";

// console.log("MUI_LICENSE_KEY: ", process.env.REACT_APP_MUI_LICENSE_KEY)
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY as string);

const queryClient = new QueryClient();

// if (process.env.NODE_ENV === 'development') {
//   const { worker } = require('./mocks/browser');
//   worker.start();
// }

const LanguageGate = () => {
  useUrfReceiveEvents();
  const language = useConfigStore((state) => state.language);

  useEffect(() => {
    void initI18n();
  }, []);

  useEffect(() => {
    void ensureAppLanguage(language);
  }, [language]);

  useEffect(() => {
    const stopPollOnLeave = () => stopLifecycleAsyncTaskPoll();
    window.addEventListener("pagehide", stopPollOnLeave);
    return () => {
      window.removeEventListener("pagehide", stopPollOnLeave);
      // Stop only when the LCM sub-app is torn down (not on in-app route changes).
      stopLifecycleAsyncTaskPoll();
    };
  }, []);

  return (
    <SnackbarProvider
      maxSnack={2}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <SnackbarUtilsConfigurator />
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </SnackbarProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  // <SnackbarProvider
  //   maxSnack={1}
  //   anchorOrigin={{ vertical: "top", horizontal: "center" }}
  // >
  //   <SnackbarUtilsConfigurator />
  //   <QueryClientProvider client={queryClient}>
  //     <App />
  //   </QueryClientProvider>
  // </SnackbarProvider>
  <LanguageGate />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
